import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "../common/table/table";

class TeamsTable extends Component {
  columns = [
    {
      key: "edit",
      className: "col-1",
      content: team => (
        <Link to={`/teams/${team.id}`} className="btn btn-info btn-sm">
          <i className="fa fa-edit" />
        </Link>
      )
    },
    {
      key: "delete",
      className: "col-1",
      content: team => (
        <button
          onClick={() => this.props.onDelete(team)}
          className="btn btn-danger btn-sm"
        >
          <i className="fa fa-trash" />
        </button>
      )
    },
    { key: "name", label: "Name", className: "col-6" },
    { key: "addInf", label: "Add. Inf.", className: "col-4" }
  ];

  render() {
    const { teams, onSort, sortColumn } = this.props;

    return (
      <div className="container">
        <Table
          columns={this.columns}
          sortColumn={sortColumn}
          onSort={onSort}
          data={teams}
        />
      </div>
    );
  }
}

export default TeamsTable;



// WEBPACK FOOTER //
// ./src/components/teams/teamsTable.jsx